import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-black pb-24 pt-14" data-id="element-39" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl px-6 lg:px-12" data-id="element-40" data-mp="3ggaohovss12a">
        <h2 className="text-center text-xs uppercase tracking-[0.3em] text-neutral-500" data-id="element-41" data-mp="32nun0sijob3h">
          Políticas del sitio
        </h2>
        <div className="mt-6 space-y-4 text-center text-[11px] leading-relaxed text-neutral-400 sm:text-xs" data-id="element-42" data-mp="36qhgsyys063b">
          <p data-id="element-43" data-mp="3ugbs3c3g5mlg">
            Los servicios ofrecidos por Magia Poderosa son de carácter espiritual, esotérico y de
            entretenimiento. No constituyen ni sustituyen asesoría médica, psicológica, legal,
            financiera ni ningún otro servicio profesional regulado. Si atraviesas una emergencia
            de salud física o mental, comunícate de inmediato con el 911 o con un profesional
            certificado.
          </p>
          <p data-id="element-44" data-mp="2a1jl9ej7c453">
            Los resultados descritos en los testimonios corresponden a experiencias personales de
            nuestros consultantes y no representan una garantía de resultados. Cada caso es
            distinto y depende de la disposición, la fe y el compromiso de la persona. No
            garantizamos resultados específicos ni plazos determinados. Los servicios se ofrecen
            únicamente a personas mayores de 18 años.
          </p>
          <p data-id="element-45" data-mp="3q7u1bojhypzf">
            Toda la información compartida durante una consulta se trata de forma confidencial y no
            se vende ni se comparte con terceros. Al comunicarte con nosotros por teléfono, correo
            electrónico o WhatsApp, aceptas recibir respuestas por esos mismos medios; puedes
            solicitar la baja en cualquier momento escribiendo a nuestro correo de contacto. Las
            tarifas de mensajes y datos de tu operador pueden aplicar.
          </p>
          <p data-id="element-46" data-mp="qujlpo9e5h1z">
            Los pagos por consultas y trabajos espirituales no son reembolsables una vez iniciado
            el proceso. Nos reservamos el derecho de rechazar cualquier solicitud que consideremos
            contraria a nuestros principios éticos o a la ley aplicable.
          </p>
          <p className="pt-2 text-neutral-500" data-id="element-47" data-mp="ytef42vrbmlv">
            © {new Date().getFullYear()} Magia Poderosa. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}